import { useState } from 'react'
import img from './assets/contact-form-img.png'
import Asterisk from './icons/asterisk'
import { Container } from './container'
import { app, translate } from '../app'
import { languages } from "../locale"
import { translations } from '../translations'
import { Loader } from './loader'
import { BlockChannels } from './blockchannels'
import { Footer } from './footer'
import { CookieBanner } from './cookie-banner'
import { CheckCircleOutlined, MailOutlined } from './icons'



const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  })
  const [responseMessage, setResponseMessage] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSent, setIsSent] = useState(false)
  const isRTL = languages[app.locale]?.rtl


  const blocks = app.page.content || []

  const blockview = blocks.map((b, i) => {
    if (b.type === "channels") return <BlockChannels key={b.sort} block={b as BlockChannels} />
    return null
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)

    const { name, email, subject, message } = formData

    const payload = {
      ticket: {
        requester: { name, email },
        subject,
        comment: { body: message },
        priority: 'normal',
        brand_id: app.zendeskBrandId
      },
    }

    try {
      const response = await fetch(`https://directus-qa-support.azurewebsites.net/contact/${app.zendeskDomain}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      })
      if (response.ok) {
        setResponseMessage('Your message has been sent successfully!')
        setFormData({ name: '', email: '', subject: '', message: '' })
        setIsSubmitting(false)
        setIsSent(true)
      } else {
        const result = await response.json()
        setResponseMessage(`Error: ${result.error}`)
      }
    } catch (error) {
      setIsSubmitting(false)
      setIsSent(false)
      setResponseMessage(`An error occurred: ${error.message}`)
    }
  }

  return (
    <div className={`contact-us w-full flex flex-col overflow-y-auto justify-start h-full ${isRTL ? 'rtl' : ''}`}>
      <Container>
        <div className={`w-[calc(100% - 216px)] flex justify-center items-start py-[32px] lg:py-[52px]${isRTL ? 'rtl' : ''}`}>
          <div className='w-full md:flex-[0.5] flex-col md:flex-row mx-0 lg:mx-[64px] xl:mx-[108px]'>
            <h1 className={`font-caslon font-bold text-[44px] leading-[56px] text-neutral-900 mb-8 mt-0 ${isRTL ? 'rtl:mr-1 rtl:ml-0 text-right' : 'text-left'}`} style={{ direction: isRTL ? "rtl" : "ltr" }}>
              {translate(translations.contactForm)}
            </h1>
            <p className={`text-neutral-icon font-normal text-[20px] leading-[32px] font-inter max-w-[386px] mb-12 ${isRTL ? 'mr-0 ml-0 text-right' : 'ml-0 text-left'}`} style={{ direction: isRTL ? "rtl" : "ltr" }}>
              {translate(translations.contactFormDescription)}
            </p>
            <form onSubmit={handleSubmit}>
              <div className={`contact-input mb-8 ${isRTL ? 'rtl:mr-1 rtl:ml-0 text-right' : 'text-left'}`} style={{ direction: isRTL ? "rtl" : "ltr" }}>
                <div className='mb-2'>
                  <Asterisk aria-hidden="true" />
                  <label htmlFor='name' className='ml-1 text-black'>{translate(translations.name)}</label>
                </div>
                <input
                  type='text'
                  id='name'
                  name='name'
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder='John Doe'
                  className='flex h-12 w-full items-center rounded-md border border-[#DDD] bg-neutral-field-background placeholder:text-text-neutral-icon'
                />
              </div>

              <div className={`contact-input mb-8 ${isRTL ? 'rtl:mr-1 rtl:ml-0 text-right' : 'text-left'}`} style={{ direction: isRTL ? "rtl" : "ltr" }}>
                <div className='mb-2'>
                  <Asterisk aria-hidden="true" />
                  <label htmlFor='email' className='ml-1 text-black'>{translate(translations.email)}</label>
                </div>
                <input
                  type='email'
                  id='email'
                  name='email'
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder='johndoe@example.com'
                  className='flex h-12 w-full items-center rounded-md border border-[#DDD] bg-neutral-field-background placeholder:text-text-neutral-icon'
                />
              </div>
              <div className={`contact-input mb-8 ${isRTL ? 'rtl:mr-1 rtl:ml-0 text-right' : 'text-left'}`} style={{ direction: isRTL ? "rtl" : "ltr" }}>
                <div className='mb-2'>
                  <Asterisk aria-hidden="true" />
                  <label htmlFor='subject' className='ml-1 text-black'>{translate(translations.subject)}</label>
                </div>
                <input
                  type='text'
                  id='subject'
                  name='subject'
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder={translate(translations.subjectPlaceholder)}
                  className='flex h-12 w-full items-center rounded-md border border-[#DDD] bg-neutral-field-background placeholder:text-text-neutral-icon'
                />
              </div>
              <div className={`contact-input ${isRTL ? 'rtl:mr-1 rtl:ml-0 text-right' : 'text-left'}`} style={{ direction: isRTL ? "rtl" : "ltr" }}>
                <div className='mb-2'>
                  <Asterisk aria-hidden="true" />
                  <label htmlFor='message' className='ml-1 text-black'>{translate(translations.message)}</label>
                </div>
                <textarea
                  id='message'
                  name='message'
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder={translate(translations.yourMessageHere)}
                  className='flex h-12 w-full items-center rounded-md border border-[#DDD] bg-neutral-field-background placeholder:text-text-neutral-icon'
                  style={{ fontFamily: 'inherit' }}
                />
              </div>
              <div className='mt-12 mb-3 text-black'>
                {/* <label className='hover:text-[#555] cursor-pointer select-none'>
                <input type='checkbox' name='terms' required className='mr-2' />I accept the{' '}
                  <Link to="/new" ><span className='underline underline-offset-2 text-black hover:text-link-hover '>terms</span></Link>
                </label> */}
              </div>
              <button type='submit' className='form-submit' disabled={isSubmitting || isSent}>
                {isSubmitting ? (
                  <>
                    <Loader size={20} /> {translate(translations.loading)}
                  </>
                ) : isSent ? (
                  <>
                    {translate(translations.sent)} <CheckCircleOutlined />
                  </>
                ) : (
                  <>
                    {translate(translations.submit)} <MailOutlined />
                  </>
                )}
              </button>
            </form>
            {responseMessage && <p className='text-red-500 text-sm' role="alert">{responseMessage}</p>}
          </div>
          <div className='hidden lg:flex flex-[0.5] sticky top-0'>
            <img src={img} alt='Contact form' className='rounded-2xl w-full h-auto max-w-[598px] max-h-[598px]' />
          </div>
        </div>
      </Container>
      {blockview}
      <Footer />
      <CookieBanner />
    </div>
  )
}

export default ContactUs
